EventTool.prototype._setEventsByType = function (sType, rData, sUid) {
    for (var i = 0, oEvent; i < rData.length; i++) {
        oEvent = rData[i];
        var jMarker = $("<li></li>");
        var jContent = "";

        var jPopup = $("<a href='javascript:;' rel='tooltip' data-placement='top' data-html='true'></a>");
        var Height = oEvent.Y2 - oEvent.Y1;
        var Width = oEvent.X2 - oEvent.X1;
        var HeightOffset = Height + 10;
        if (sType == "Dividends") {
        	jContent = this._buildDividendMarkerPopup(oEvent);
        } else if (sType == "Splits") {
            jContent = this._buildSplitMarkerPopup(oEvent);
		} else if (sType == "RatingsChanges") {
            jContent = this._buildRankChangePopup(oEvent);
		} else if (sType == "Earnings") {
			jContent = this._buildEarningsMarkerPopup(oEvent);
			HeightOffset = 0;
		} else if (sType == "Commentary" || sType == "ResearchNote") {
			HeightOffset = 0;
            jPopup.addClass("event-commentary module-expand");
            jPopup.attr("data-type", "5");
            jPopup.attr("data-date", oEvent.Date);
            jPopup.attr("data-context", (sType == "Commentary" ? this._getCommentaryContext(oEvent.Date) : this._getResearchNoteContext(oEvent.Date)));
        }

        jPopup.attr("data-title", jContent);
        jPopup.css({ left: oEvent.X1 + "px", top: (oEvent.Y1 - HeightOffset) + "px", width: Width + "px", height: Height + "px" });
        jMarker.append(jPopup);

        this._markerContainer.append(jMarker);
    }

    // Init the tooltips 
    var self = this;
    if (sType == "Commentary" || sType == "ResearchNote") {
        this._markerContainer.find("a[rel=tooltip]").tooltip({
            maxWidth: 215,
            onEnter: $.proxy(this._handleCommentary, this),
            pauseOnHover: true,
            delay: { show: 0, hide: 500 }
        });
    } else {
        this._markerContainer.find("a[rel=tooltip]").tooltip();
    }
};

EventTool.prototype._buildDividendMarkerPopup = function (oEvent) {
    return "<div><p><span class='bold'>Dividend</span></p><p>" + this.formatDate(oEvent.Date) + "</p><p>" + oEvent.Value + "</p></div>";
};

EventTool.prototype._buildSplitMarkerPopup = function (oEvent) {
    return "<div><p><span class='bold'>Split</span></p><p>" + this.formatDate(oEvent.Date) + "</p><p>Executed a " + oEvent.Split + " Split</p></div>";
};

EventTool.prototype._buildEarningsMarkerPopup = function (oEvent) {
    return "<div><p><span class='bold'>Earnings Announcement</span></p><p>" + this.formatDate(oEvent.Date) + "</p><p>Actual EPS " + oEvent.Value.toFixed(2) + "</p><p>Analyst Estimate " + (oEvent.Estimate > 0 ? oEvent.Estimate.toFixed(2) : "--") + "</p><p>Surprise Percent " + this._formatEarnings(oEvent.Surprise) + "</p></div>";
};

EventTool.prototype._buildRankChangePopup = function (oEvent) {
	return "<div><p><span class='bold'>Rank Change</span></p><p>Commentary Date: " + this.formatDate(oEvent.Date) + "</p><p>Rank &amp; Rating Changes: " + this._checkIfLocked(oEvent.Value) + "</p></div>";
};

EventTool.prototype.formatDate = function (msDate) {
    var d = msToJsDate(msDate);
    return (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear();
};

EventTool.prototype._checkIfLocked = function (value) {
    if (value == -2147483648) {
        return "<i class='icon-locked'></i>";
    } else {
        return value;
    }
};

EventTool.prototype._formatEarnings = function (surprise) {
    if(surprise == 0) {
        return "--";
    } else if (surprise > 0) {
        return "+" + surprise.toFixed(2);
    } else {
        return surprise.toFixed(2);
    }
};

EventTool.prototype._getCommentaryContext = function (msDate) {
    var d = msToJsDate(msDate);
    var oDate = {};
    var month = d.getMonth();
    if (month < 3) {
        oDate.SelectedQtr = 1;
    } else if (month < 6) {
        oDate.SelectedQtr = 2;
    } else if (month < 9) {
        oDate.SelectedQtr = 3;
    } else {
        oDate.SelectedQtr = 4;
    }
    oDate.SelectedYear = d.getFullYear();

    return JSON.stringify(oDate);
};

EventTool.prototype._getResearchNoteContext = function (msDate) {
    var oDate = {};
    oDate.ResearchNoteDate = this.formatDate(msDate);
    return JSON.stringify(oDate);
};

EventTool.prototype._handleCommentary = function (tooltip) {
    var $el = tooltip.$element;
    var title = $el.attr("data-title");
    if (!title) {
        //$el.trigger("mouseleave");
        var oContext = $el.data("context");
        var oData = {};
        oData.Symbol = this._chart.GetSymbolInput();
        oData.BundleId = this._chart.GetBundleInput();
        oData.Product = this._chart.GetProductInput();
        oData.ResearchNoteDate = (oContext.ResearchNoteDate ? oContext.ResearchNoteDate : "");
        oData.SelectedQtr = (oContext.SelectedQtr ? oContext.SelectedQtr : "");
        oData.SelectedYear = (oContext.SelectedYear ? oContext.SelectedYear : "");

        this._fetchCommentary(oData, $el);
    }
};

EventTool.prototype._attachCommentaryEvents = function (tooltip) {
    var $el = tooltip.$element;
};

EventTool.prototype._fetchCommentary = function (oInputs, $el) {
    var self = this;
    $.ajax({
        type: "POST",
        data: { inputData: JSON.stringify(oInputs) },
        dataType: "json",
        url: this._chart.API_COMMENTARY.resolveUrl(),
        success: function (response) {
            self._renderCommentary(response, $el);
        },
        error: function () {
            $el.attr("data-title", "<p>No commentary available.</p>");
        }
    });
};

EventTool.prototype._renderCommentary = function (oResponse, $el) {
    if (oResponse.text) {
        var html = "<div><p><span class='bold'>" + oResponse.type + ":</span> " + oResponse.date + "</p><p>" + oResponse.text + "</p><a class='link-color' href='javascript:;' onClick='$(\"a.event-commentary[data-date=" + oResponse.rawDate + "]\").trigger(\"click\");'>Read more &raquo;</a></div>";
    } else {
        var html = "<p>No commentary available.</p>";
    }
    $el.attr("data-title", html);
    $el.trigger("mouseenter");
};
